const TEAMS = "TEAMS";
const TALENT = "TALENTS";
const DEFAULT_ANSWER = -1;

export default [
  {
    name: "Radio On-Air-Personality (Male)",
    options: [
      "Sammy Wejinya (Beat, Classic & Naija FM)",
      "Kofi Bartels (Nigerian Info)",
      "Kenneth Ogbunehu (Wish FM)",
      "Imoh Ebong (Passion FM)",
      "Smart Uzoeshi (Love FM)"
    ]
  },
  {
    name: "Radio On-Air-Personality (Female)",
    options: [
      "Pat Idowu (Love FM)",
      "Enoh Ogbevire (Nigerian Info)",
      "Karina Israel (Rhythm FM)",
      "Anni Abdulsalam (Today FM)",
      "Sunshine Nchelem (Beat FM)"
    ]
  },
  {
    name: "TV On-Air-Personality (Male)",
    options: [
      "Aaron Itode (AIT)",
      "Ochuko Omiragwa (Wazobia TV)",
      "Perry Tukuwei (AIT)",
      "Mayowa Daramola (Wazobia TV)",
      "Ephraim Emmanuel (Silverbird TV)"
    ]
  },
  {
    name: "TV On-Air-Personality (Female)",
    options: [
      "Esther Nweje (Silverbird TV)",
      "Sisi Boma (Wazobia TV)",
      "Flora Duke (Silverbird TV)",
      "Adaku Nwachinemere (SilverbirdTV)",
      "Onyiyechi Okpala Perpetual (AIT)"
    ]
  },
  {
    name: "Radio Newscaster",
    options: [
      "Carl Orakwe (Nigeria Info & Cool FM)",
      "Victoria Longjohn (Beat & Classic FM)",
      "Constance Iroele (Love FM)",
      "Joy Eberebe (Nigeria Info & Cool FM)",
      "Ben Wakama (Rhythm FM)"
    ]
  },
  {
    name: "TV Newscaster",
    options: [
      "Esther Ogan (Wazobia Max TV)",
      "Flora Duke (Silverbird TV)",
      "Ephraim Emmanuel (Silverbird TV)",
      " Isaiah Jennifer (AIT Yenagoa)",
      "Dew Jemima Wilson (DBS, Asaba)"
    ]
  },
  {
    name: "Rising Star (Radio)",
    options: [
      "Aina-Padonou Rey (Cool FM)",
      "Peace Pollyn - Pizza on Radio (Wave FM)",
      "Chiamaka Honey Ojukwu (Cool FM)",
      "Chidinma Vivian Udeh (Ima Sound City) ",
      "Dennis Denise (Nigeria Info)"
    ]
  },
  {
    name: "Rising Star (Television)",
    options: [
      "Jennifer (Wazobia Max TV)",
      "Dooake Ebi Jr. (AdureTV)",
      "Stephanie Blackpearl Ubozoh",
      "Jennifer Isaiah (AIT Yenagoa)",
      "Boma Pepple (No Limit TV)"
    ]
  },
  {
    name: "Sports On-Air-Personality",
    options: [
      "Sammy Wejinya (Beat, Classic & Naija FM)",
      "China Acheru (Wish FM)",
      "Carl Orakwe (CoolWazobiaInfo)",
      "Deinma Abaku (Wave FM) ",
      "Benjamin Salvadinho (Nigeria Info & Cool FM) "
    ]
  },
  {
    name: "Radio Host (Inspirational)",
    options: [
      "Enoh Ogbevire (Nigeria Info FM)",
      "Smart Uzoeshi (Love FM)",
      "Nana Abyna (Passion FM Uyo)",
      "Kate Ogan (Wave FM)",
      "Dawn Wilson (Garden City FM)"
    ]
  },
  {
    name: "Radio Host (Human Interest)",
    options: [
      "Dayo Elusakin (Nigeria Info)",
      "Kofi Bartels (Nigeria Info)",
      "Alexander Otutu (Classic FM)",
      "Afronelly Wonne ",
      "Dennis Denise (Nigeria Info)"
    ]
  },
  {
    name: "Radio host (Gospel)",
    options: [
      "Charles Baridam (Rhythm FM)",
      "Jennifer Omoko (Kpoko FM)",
      "Kofi Bartels (Nigeria Info FM)",
      "Rose Rozay Akai (Comfort FM)",
      "Aniete Akpan (Treasure FM)"
    ]
  },
  {
    name: "Pidgin On-Air-Personality",
    options: [
      "Omotalk (Wazobia FM) ",
      "Tombo belle (Naija FM)",
      "Sisi Boma (Wazobia FM)",
      "Ehidiana (Wazobia FM)",
      "Rajini Landlady (Naija FM)",
      "Sky Ogbu (Wave FM)"
    ]
  },
  {
    name: "Radio Disc Jockey",
    options: [
      "DJ Dean (Love FM)",
      "DJ Joenel (Cool FM)",
      "DJ Michael Effiong (Kpoko FM)",
      "DJ Smart Don ",
      "DJ Skillful (Ray Power)"
    ]
  },
  {
    name: "New Media",
    options: [
      "Isaac Godwin (818tvonline)",
      "Karina Youdiowei (Gistalways.ng)",
      "Darlington Ebere (Teller Africa)",
      "Alabo Jojo (Phcity promo.com)",
      "Young Endy (Young Endy’s Blog)"
    ]
  },
  {
    name: "Social Media",
    options: [
      "Tonye Briggs (Port Harcourt in pictures)",
      "Nemi Derefaka (Tweetestboi Ph)",
      "Wendy Ajikeru (Women in Port Harcourt)",
      "Tutu Abbey (Tutu of Port Harcourt)",
      "Ella Ezeadilieje (Veronicas Daughter)",
      "Chiamaka Honey Ojukwu"
    ]
  },
  {
    name: "Media Enterprise",
    options: [
      "Austin Okolo (Picture Bank & Ficus TV)",
      "Tonye Briggs (Port Harcourt in Pictures)",
      "Omojesu (SwagTV)",
      "Stanley Azubuike (Galaxy 360 Media)",
      "Christian Brian Okoli",
      "Darlington Ebere (Teller Africa)"
    ]
  },
  {
    name: "The Media Awards & Ibim Semenitari Prize for Journalism",
    options: [
      "Monica Ogwa (Rhythm FM)",
      "Philip I. Thomas (Reports Afrique)",
      "Kofi Bartels (Nigeria Info FM)",
      "Soibi Owunari (CoolWazobiaInfo)",
      "Kiki Mordi (BBC Africa)",
      "Chioma Ezenwafor (CoolWazobiaInfo)"
    ]
  },
  {
    name: "News Editor",
    options: [
      "Chioma Ezewanfor (Nigeria Info)",
      "Emeka Ortuka (CoolWazobiaInfo)",
      "Lawrence Berezi (FRCN Yenagoa)",
      "George Ukaegbu (Wave FM)",
      "Okenyi Kelechi (Port City News)"
    ]
  },
  {
    name: "Film",
    options: [
      "Matilda Lambert",
      "Jane Gem Dede",
      "Austin Okolo",
      "Jennifer Nkem-Eneaya",
      "Mark Angel"
    ]
  }
].map(e => ({ ...e, group: TALENT, answer: DEFAULT_ANSWER }));

export const TEAMS_POLL = [
  {
    name: "Award for Radio Station of the Year",
    options: [
      "Rhythm FM",
      "Nigeria Info FM",
      "Inspiration FM",
      "Beat FM ",
      "Wave FM",
      "Cool FM",
      "Ray Power FM"
    ]
  },
  {
    name: "Award for Television Station of the Year",
    options: [
      "AIT",
      "Silverbird TV",
      "Wazobia Max TV",
      "TVC ",
      "NTA",
      "RSTV",
      "Channels TV "
    ]
  },
  {
    name: "Award for Magazine of the year",
    options: [
      "Eve Afrique",
      "Guardian Life",
      "Orange Magazine",
      "Genevieve Magazine",
      "G-Influence Magazine"
    ]
  },
  {
    name: "Award for Newspaper of the year (Local)",
    options: [
      "Port Harcourt Microscope",
      "Africa Update ",
      "The Tide",
      "The Port City News",
      "Reports Afrique"
    ]
  },
  {
    name: "Award for Newspaper of the year (National)",
    options: ["The Guardian", "Punch", "Daily Trust", "This Day", "Vanguard"]
  }
].map(e => ({ ...e, group: TEAMS, answer: DEFAULT_ANSWER }));
